/**
 * TotalSalesStatus
 * --
 */
import { useState, useEffect } from 'react';
import { Content, Title, Row, Col } from 'components';
import { Button, Statistic, Spin } from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import MessageAlert, { strCut, stringToMoneyFormat } from 'utils';
import moment from 'moment';
import { useUserStack } from 'store';
const MOMENT_FORMAT = 'YYYY-MM-DD';
const today = moment().format(MOMENT_FORMAT);

/**----------------------------------------
 * [Component] 홈 > 매장별 매출 차트
 * ----------------------------------------
 */
const TotalSalesStatus = ({
  loading,
  mallList,
  storeList,
  isMobile,
  // currentShop,
  // permission,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  // console.log('[TotalSalesStatus] mallList: ', mallList);
  // console.log('[TotalSalesStatus] storeList: ', storeList);

  const mallData = mallList.filter(
    (item) => moment(item.date).format(MOMENT_FORMAT) === today
  );
  const storeData = storeList.filter(
    (item) => moment(item.date).format(MOMENT_FORMAT) === today
  );

  const totalAmountMall = mallData.reduce(
    (acc, cur) => (acc += Number(cur.totalAmount ?? 0)),
    0
  );
  const netsAmountMall = mallData.reduce(
    (acc, cur) => (acc += Number(cur.netsAmount ?? 0)),
    0
  );
  const totalAmountStore = storeData.reduce(
    (acc, cur) => (acc += Number(cur.totalAmount ?? 0)),
    0
  );
  const netsAmountStore = storeData.reduce(
    (acc, cur) => (acc += Number(cur.netsAmount ?? 0)),
    0
  );
  /* ===== RENDER ===== */
  // JSX: start
  return (
    <>
      <Spin spinning={loading}>
        <Content
          fullWidth
          padding={0}
          backgroundColor={'none'}
          width={'100%'}
          style={{
            marginBottom: 5,
            // display: 'flex',
            // justifyContent: 'space-between',
          }}
        >
          <Row>
            {[
              // {
              //   title: '전체 매장 수',
              //   value: stringToMoneyFormat(storeList.length),
              //   suffix: '개',
              //   link: '/shipping/list/PREPARING',
              // },
              {
                title: '매장 총매출',
                value: stringToMoneyFormat(Number(totalAmountStore ?? 0)),
                suffix: '원',
                link: '/shipping/list/ON_HOLD',
              },
              {
                title: '매장 순매출',
                value: stringToMoneyFormat(Number(netsAmountStore ?? 0)),
                suffix: '원',
                link: '/shipping/list/SHIPPING',
              },
            ].map((_item, _index) => (
              <Col key={`${_item.label}-${_index}`} x={12}>
                <div
                  className="boxShadow"
                  style={{
                    background: '#FFFFFF',
                    borderRadius: 4,
                    width: `98.5%`,
                    height: `98%`,
                    margin: '0 2px',
                    padding: '16px 15px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <Statistic
                    className="cursorOverOpacity"
                    direction={'row'}
                    size="large"
                    title={_item.title}
                    value={_item.value}
                    suffix={_item.suffix}
                    // style={{ justifyContent: 'center' }}
                    valueStyle={{
                      fontSize: '1.45em',
                      color:
                        _item.value === '0' || _item.value === 0
                          ? '#7f7f7f'
                          : '#1677ff',
                      // textDecoration: 'underline !important',
                    }}
                  />
                  <div>
                    {/* <Button
                      shape="circle"
                      onClick={() => window.open(_item.link, '_blank')}
                    >
                      <ExportOutlined />
                    </Button> */}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Content>
      </Spin>
    </>
  ); // JSX: end
};

TotalSalesStatus.defaultProps = {
  mallList: null,
};
export default TotalSalesStatus;
